import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import styled from 'styled-components';
import NavBar from '../Components/NavBar/NavBar';
import Contacts from '../Pages/Contacts/Contacts';
import AgregarContacto from '../Pages/Contacts/AgregarContacto';
import CreateUserForm from './CreateUserForm';
import Asesores from './Asesores/Asesores';
import Ventas from "../Pages/Ventas/Ventas";
import MyCalendar from "./Agenda/Agenda1";
import Productores from "./Productores/Productores";
import Clientes from "./Clientes/Clientes";
import Seguimientos from "./Seguimientos/Seguimientos"
import { useNavigate } from 'react-router-dom';
import Preferencias from "./Opciones/Preferencias.jsx"
import Flag from "./Flag"
import fondo2 from "./fondo2.svg"
import NavbarHorizontal from "../Components/NavBar/NavbarHorizontal.jsx"
import Organizaciones from "./Organizaciones/Organizaciones.jsx"
import { useWindowWidth } from "@react-hook/window-size";
import CrearOrganizacion from "./Organizaciones/CrearOrganizacion.jsx"
import DetailOrganizacion from "./Organizaciones/DetailOrganizacion.jsx"
import UserProfile from "./User/UserProfile.jsx"
import Cobranzas from "./Cobranzas/Cobranzas"

const Dashboard = () => {
  const navigate = useNavigate()
  const onlyWidth = useWindowWidth();
  const [user, setUser] = useState({});
  const [openNav, setOpenNav] = useState(false);
  const [alertWelcome, setAlertWelcome] = useState(false);
  const location = useLocation();
  const params = useParams();

  const setOpenMovileNav = () => {
    setOpenNav(!openNav)
  }

  useEffect(() => {
    // Recuperar el valor de 'selectedMarca' del almacenamiento local
    const userLogin = localStorage.getItem('user');
    if (userLogin !== undefined && userLogin !== null && userLogin.trim() !== '') {
      // console.log(userLogin)
      setUser(JSON.parse(userLogin));
    } else {
      navigate("/login")
    }

    const alertwel = localStorage.getItem('alert');
    if (alertwel) {
      setAlertWelcome(JSON.parse(alertwel));
    }
  }, []);
  return (

    <ContainerContacts>

      {
        user.id ? <>
          <NavbarHorizontal
            user={user}
            setOpenMovileNav={setOpenMovileNav}
          />
          {
            onlyWidth < 1100 ?
              null :
              <NavBar
                user={user}
                alertWelcome={alertWelcome}
              />
          }


          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              width: onlyWidth < 1100 ? "100%" : "89%",
              marginTop: "60px",
              padding: "16px 16px"
            }}
          >

            {location.pathname === '/contacts' ? (

              <Contacts user={user} />

            ) : null}
            {location.pathname === '/contacts' + '/' + params?.id ? (

              <Contacts user={user} />

            ) : null}

            {location.pathname === '/create-user' ? (

              <CreateUserForm user={user} />

            ) : null}

            {location.pathname === '/add-contacts' ? (

              <AgregarContacto user={user} />

            ) : null}

            {location.pathname === '/asesores' ? (

              <Asesores user={user} />

            ) : null}
            {location.pathname === '/asesores' + '/' + params?.id ? (

              <Asesores user={user} />

            ) : null}

            {location.pathname === '/productores' ? (

              <Productores user={user} />

            ) : null}
            {location.pathname === '/productores' + '/' + params?.id ? (

              <Productores user={user} />

            ) : null}
            {location.pathname === '/seguimientos' ? (

              <Seguimientos user={user} />

            ) : null}
            {location.pathname === '/seguimientos' + '/' + params?.id ? (

              <Seguimientos user={user} />

            ) : null}
            {location.pathname === '/ventas' ? (

              <Ventas user={user} />
              // <ContainerBox></ContainerBox>
            ) : null}
            {location.pathname === '/clientes' ? (

              <Clientes user={user} />

            ) : null}
            {location.pathname === '/clientes' + '/' + params?.id ? (

              <Clientes user={user} />

            ) : null}


            {
              location.pathname === '/' ?
                (

                  <Ventas user={user} />
                ) : null
            }
            {
              location.pathname === '/agenda' ?
                (

                  <MyCalendar user={user} />
                ) : null
            }
            {
              location.pathname === "/cobranza" ?
              (
                <Cobranzas user={user} />
              ) : null
            }

            {
              location.pathname === '/opciones' ?
                (

                  <Preferencias user={user} />
                ) : null
            }

            {
              location.pathname === "/organizaciones" ?
                (
                  <Organizaciones user={user} />
                ) : null
            }
            {
              location.pathname === "/organizaciones/create-organizacion" ?
                (
                  <CrearOrganizacion user={user} />
                ) : null
            }
            {
              location.pathname === "/organizaciones/editar" + '/' + params?.id ?
                (
                  <CrearOrganizacion user={user} />
                ) : null
            }
            {
              location.pathname === "/organizaciones" + '/' + params?.id ?
                (
                  <DetailOrganizacion user={user} />
                ) : null
            }
                     {
              location.pathname === "/profile" ?
                (
                  <UserProfile user={user} />
                ) : null
            }
          </div>

        </> : null
      }


    </ContainerContacts>

  );
};

export default Dashboard;

const ContainerContacts = styled.div`
background-color: #f9f9fc;
width: 100%;
display: flex;
flex-direction: row;
justify-content: flex-start;
align-items: flex-start;
background-size: cover;
background-position: center;
height: 100vh;
`;



